var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 4.81296C13.3594 4.98096 13.291 5.14896 13.1536 5.27715L7.99784 10.0892C7.72362 10.3456 7.27831 10.3456 7.00362 10.0892L1.84737 5.27715C1.57269 5.02078 1.57269 4.60559 1.84737 4.34921C2.12159 4.09284 2.56691 4.09284 2.84159 4.34921L7.5005 8.69709L12.1589 4.34921C12.4336 4.09284 12.8785 4.09284 13.1532 4.34921C13.291 4.47696 13.3594 4.64496 13.3594 4.81296Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.38cdabc035985ca8c4b9c6547d212630.svg";
export { ForwardRef as ReactComponent };